import { render, staticRenderFns } from "./ButtonAbsence.vue?vue&type=template&id=797bb3c5&scoped=true&"
import script from "./ButtonAbsence.vue?vue&type=script&lang=js&"
export * from "./ButtonAbsence.vue?vue&type=script&lang=js&"
import style0 from "./ButtonAbsence.vue?vue&type=style&index=0&id=797bb3c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797bb3c5",
  null
  
)

export default component.exports